<template>
  <div class="uk-container">
    <button
      class="uk-button uk-button-primary uk-margin-small uk-border-rounded"
      v-if="!getUser"
      @click="signIn('facebook')"
    >
      Zaloguj FB
    </button>
    <button
      class="uk-button uk-button-primary uk-margin-small uk-border-rounded"
      v-if="!getUser"
      @click="signIn('google')"
    >
      Zaloguj GGL
    </button>
    <button
      class="uk-button uk-button-danger uk-margin-small uk-border-rounded"
      v-else
      @click="signOut"
    >
      Wyloguj
    </button>
    <img v-if="getUser" :src="getUser.photoURL" />
    {{ getUser }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Account',
  computed: {
    ...mapGetters(['getUser'])
  },
  data() {
    return {}
  },
  methods: {
    signIn(type) {
      this.$router.push({
        name: 'login',
        params: {
          type: type
        },
        query: { redirectUrl: window.location.pathname }
      })
    },
    signOut() {
      this.$store.dispatch('signOut')
    }
  }
}
</script>

<style lang="scss" scoped></style>
